import { Box } from "@mui/material";
import Loading from "@notemeal/shared/ui/global/Loading";
import { TWTabGroup } from "apps/web/src/componentLibrary/TWTabGroup/TWTabGroup";
import { useOffsetPagination } from "apps/web/src/utils/pagination";
import { useOrgFoodGroupsTableQuery, useSharedFoodGroupsTableQuery } from "libs/shared/ui/src/lib/types";
import React, { useState } from "react";
import { FoodGroupDashboard } from "../../../../components/FoodGroup/Dashboard";
import { makeUpdateCacheCreateFoodGroup } from "../../../../components/FoodGroup/utils";
import { useCreateOrgFoodGroupMutation, useEditOrgFoodGroupMutation } from "../../../../types";
import { EntityScope } from "../../../../utils/scope";

export interface FoodGroupDashboardProps {
  scope: EntityScope;
}

export const FoodGroupsPage = () => {
  const [sortOrder, setSortOrder] = useState<"ASC" | "DESC">("ASC");
  const paginationHooks = useOffsetPagination();
  const { limit, offset, query } = paginationHooks;
  const orgQueryResult = useOrgFoodGroupsTableQuery({
    variables: {
      query,
      input: {
        limit,
        offset,
      },
      sortOrder,
    },
  });
  const sharedQueryResult = useSharedFoodGroupsTableQuery({
    variables: { query, input: { limit, offset }, sortOrder },
  });

  const CUSTOM = "Custom";
  const STANDARD = "Standard";
  const [selected, setSelected] = useState(CUSTOM);
  const tabs = [CUSTOM, STANDARD];

  const [createFoodGroup] = useCreateOrgFoodGroupMutation({});
  const updateCacheCreateFoodGroup = makeUpdateCacheCreateFoodGroup({
    scope: "org",
  });

  const [editFoodGroup] = useEditOrgFoodGroupMutation({});

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
      <TWTabGroup tabs={tabs} onSelected={selected => setSelected(selected)} />
      {selected === CUSTOM ? (
        !orgQueryResult.data || !!orgQueryResult.loading ? (
          <Loading />
        ) : (
          <FoodGroupDashboard
            editFoodGroup={editFoodGroup}
            createFoodGroup={createFoodGroup}
            updateCacheCreateFoodGroup={updateCacheCreateFoodGroup}
            foodGroups={orgQueryResult.data.orgFoodGroupsOffsetConnection.edges}
            paginationHooks={paginationHooks}
            total={orgQueryResult.data.orgFoodGroupsOffsetConnection.pageInfo.total}
            setSortOrder={setSortOrder}
            sortOrder={sortOrder}
          />
        )
      ) : !sharedQueryResult.data || !!sharedQueryResult.loading ? (
        <Loading />
      ) : (
        <FoodGroupDashboard
          readOnly
          foodGroups={sharedQueryResult.data.sharedFoodGroupsOffsetConnection.edges}
          paginationHooks={paginationHooks}
          total={sharedQueryResult.data.sharedFoodGroupsOffsetConnection.pageInfo.total}
          setSortOrder={setSortOrder}
          sortOrder={sortOrder}
        />
      )}
    </Box>
  );
};
